export function formatCurrency(amount) {
  return `$${Number(amount).toFixed(2)}`;
}

export function calcTotal(items) {
  return items.reduce((prev, item) => prev + item.quantity * item.price, 0);
}

export function calcTip(subtotal, percent, custom, automaticGratuity) {
  if (percent === 'custom') {
    return Number(custom) || 0;
  }

  if (automaticGratuity) {
    return 0;
  }

  return (subtotal * Number(percent)) / 100 || 0;
}
